import {
	getModule,
	Module,
	VuexModule,
	Mutation,
	Action,
} from 'vuex-module-decorators';
import store from '@/store';
import fb from '../gobi-mw-firestore';
import {
	User, LoginSubmission, ProcessState, StateKeyPairs,
	LoginStatus, TypicalResponse, SetSupportLvlResponse, AccountMinimumData,
	AccountMinimumDataDic,
} from '../models.def';
import userz from '../userz';

(window as any).store = store;
@Module({
	namespaced: true,
	name: 'userx',
	store,
	dynamic: true,
})
class UsersModule extends VuexModule {

	public signinState: ProcessState = ProcessState.Undefined;
	public loginStatus: LoginStatus = 'loading';
	public user: User | null = null;

	public emailVerificationSent = false;
	public myAccountsDic: AccountMinimumDataDic = {};

	public recentInvitedEmails: Set<string> = new Set<string>();

	get displayName(): string | null | undefined {
		return (this.user && this.user.displayName);
	}
	get uid(): string | null | undefined {
		return (this.user && this.user.uid);
	}
	get supportLvl(): number | undefined | null {
		return (this.user && this.user.supportLvl);
	}

	get needCompleteRegistration(): boolean | undefined {
		if (!this.user || this.user.noPassword === undefined) { return undefined; }
		if (this.user.displayName === '' || this.user.noPassword === true) { return true; }
		return false;
	}
	public get myAccounts(): AccountMinimumData[] {

		return Object.values(this.myAccountsDic)
			.filter((account) => account !== null) as AccountMinimumData[];
	}

	@Mutation
	public m_updateUser(user: User | null) {
		this.user = user;
		if (!this.user) { this.emailVerificationSent = false; }
	}

	@Mutation
	public m_updateState(keyPair: StateKeyPairs) {
		(this as any)[keyPair.key] = keyPair.state;
	}

	@Mutation
	public m_updateLoginStatus(status: LoginStatus) {
		this.loginStatus = status;
	}
	@Mutation
	public m_emailVerificationSent() {
		this.emailVerificationSent = true;
	}
	@Mutation
	public m_updateMyAccounts(accountsDic: AccountMinimumDataDic) {
		this.myAccountsDic = accountsDic;
	}
	@Mutation
	public m_addInvitedEmail(email: string) {
		this.recentInvitedEmails = new Set(this.recentInvitedEmails.add(email));
	}

	@Action
	public loginLocal(user: User | null = null) {
		this.m_updateUser(user);
		this.m_updateLoginStatus((user) ? 'logged in' : 'logged out');
		(window as any).userx = this;
	}
	@Action
	public updateUser(user: User | null = null) {
		const currentUser: User | null | undefined = (this.context.state as any).user;
		if (user && user.uid === this.uid) { this.m_updateUser(JSON.parse(JSON.stringify(user))); }
	}

	@Action
	public async logoutLocal() {
		this.loginLocal(); // passing null as arg
	}

	@Action
	public async signIn(userSubmit: LoginSubmission) {
		this.m_updateState({ key: 'signinState', state: ProcessState.Await });
		const result = await fb.loginUser(userSubmit);
		if (result.success) {
			this.m_updateState({ key: 'signinState', state: ProcessState.Succeed });
		} else {
			this.m_updateState({ key: 'signinState', state: ProcessState.Failed });
		}
		return result;
	}
	@Action
	public async signOut() {
		fb.logoutUser();
	}

	@Action
	public async updateDisplayName(displayName: string): Promise<TypicalResponse> {
		if (!this.user) { return { success: false, errorMessage: 'No User' }; }
		this.user.displayName = displayName;
		this.m_updateUser(this.user);
		const result = await fb.updateProfile({ displayName });
		return result;
	}
	@Action
	public async updatePassword(password: string): Promise<TypicalResponse> {
		if (!this.user) { return { success: false, errorMessage: 'No User' }; }
		const result = await fb.updatePassword(password);
		if (result.success) {
			this.user.noPassword = false;
			this.m_updateUser(this.user);
		}
		return result;
	}
	@Action
	public async sendSignInEmail(email: string): Promise<TypicalResponse> {
		const result = await fb.sendSignInEmail(email);
		if (result.success) {
			this.m_addInvitedEmail(email);
		}
		return result;
	}
	@Action
	public async sendEmailVerification(): Promise<TypicalResponse> {
		if (!this.user) { return { success: false, errorMessage: 'No User' }; }
		if (this.emailVerificationSent) { return { success: false, errorMessage: 'Verification Email Sent' }; }
		const result = await fb.sendEmailVerification();
		if (result.success) {
			this.m_emailVerificationSent();
		}
		return result;
	}
	@Action
	public async sendPasswordResetEmail(email: string): Promise<TypicalResponse> {
		const result = await fb.sendPasswordResetEmail(email);
		return result;
	}
	@Action
	public async setSupportLvl(target: { email: string, supportLvl: number }): Promise<SetSupportLvlResponse> {
		const result = await fb.setSupportLvl(target.email, target.supportLvl);
		return result;
	}

	@Action
	public updateMyAccounts(accountsDic: AccountMinimumDataDic) {
		this.m_updateMyAccounts(accountsDic);
	}
	@Action
	public async addMyAccount(accountData: AccountMinimumData) {
		const result = await userz.addMyAccount(accountData);
		return result;
	}
	@Action
	public async removeMyAccount(accountId: string) {
		const result = await userz.removeMyAccount(accountId);
		return result;
	}

}
export default getModule(UsersModule);
